var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCirclePrimary = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#414192",
  fillRule: "evenodd",
  d: "M16.5 1.333C8.4 1.333 1.833 7.9 1.833 16S8.4 30.667 16.5 30.667 31.166 24.1 31.166 16 24.6 1.333 16.5 1.333m6.942 11.61a1.333 1.333 0 1 0-1.885-1.886L14.5 18.114l-3.057-3.057a1.333 1.333 0 0 0-1.886 1.886l4 4c.52.52 1.365.52 1.886 0z",
  clipRule: "evenodd"
})));
export default SvgCheckCirclePrimary;